import 'bootstrap/dist/css/bootstrap.min.css';
import { Gradient } from 'react-gradient';
import {Navigation} from './components/Navigation.js';
import {WhoAmI} from './components/WhoAmI';
import { Skills } from './components/Skills';
import { Projects } from './components/Projects';
import {Container, Row, Col, Jumbotron, Card} from 'react-bootstrap';


const gradients = [
  // ['#B993D6', '#8CA6DB'], // Dirty Fog
  ['#1a2980', '#26D0CE'], // Aqua Marine
  ['#26D0CE', '#1a2980'], // Aqua Marine
  ['#314755', '#26a0da'], // Nimvelo
  ['#26a0da', '#314755'], // Nimvelo
  // ['#1d976c', '#93F9B9'] // Mojito
];


function App() {
  return (
      <div style={styles.mainContentStyle}
        // gradients={ gradients }
        // property="background"
        // duration={ 5000 }
        // angle="45deg"
        >
          
          <Navigation/>
          <WhoAmI/>
          
          <Container fluid>
            <Row>
              <Col md={1} />

              <Col>
                <Skills />
                <Projects />
              </Col>

              <Col md={1} />
            </Row>
          </Container>
          
          {/* <Footer /> */}
      </div>
      
  );
}

const styles = {
  mainContentStyle: {
    paddingLeft: 0,
    paddingRight: 0,
    minHeight: '100vh',
    // backgroundColor: '#26a0da'
    background: 'linear-gradient(to right, #1a2980, #26D0CE)'
  },

  
}

export default App;
